import {Fragment, useState} from 'react';

import {Loader} from 'components';

type Props = {
  path: string;
  alt?: string;
  imgStyle?: React.CSSProperties;
};

export const ImageWithLoader: React.FC<Props> = ({path, alt, imgStyle}: Props) => {
    const [loading, setLoading] = useState(true);

    return (
        <Fragment>
            {loading && <Loader className='tw-max-w-1/2 tw-max-h-1/2' />}
            <img
                src={path}
                alt={alt ?? path}
                loading='lazy'
                style={{
                    width: '100%',
                    height: '100%',
                    opacity: loading ? 0 : 1,
                    visibility: loading ? 'hidden' : 'visible',
                    transition: 'opacity 500ms ease',
                    ...imgStyle,
                }}
                onLoad={() => setLoading(false)}
                onError={() => setLoading(false)}
            />
        </Fragment>
    );
};
